import {
    filtersHide,
} from './filters-fix';
import debounce from '../utils/debounce';
import equaliseProductHeights from './equalise-product-heights';
import removeEmptyTags from './remove-empty-deal-tags';
const filtersSidebarContainerNode = document.querySelector('#filterSidebarContainer');
const filtersContainerNode = document.querySelector('.facet-container');
const overlayNode = document.querySelector('.overlay');
const htmlNode = document.querySelector('html');
const sortSelectDesktop = (function() {
    let select = document.querySelector('[data-desktop-filter-topbar] select[name="sort"]');
    if (!select) {
        select = document.querySelector('select[name="sort"][data-listing-sort-by]');
    }
    return select;
})();
const sortSelectMobile = (function() {
    let select = document.querySelector('[data-mobile-filter-topbar] select[name="sort"]');
    if (!select) {
        select = document.querySelector('select[name="sort"][data-listing-sort-by]');
    }
    return select;
})();
const loadMoreDealsButton = document.querySelector(
    '[data-filters-action="load-more-deals"]'
);
const localStorageKey = 'filtersToggleState';
const activeSortSelector = () => {
    if (window.innerWidth > 1024) {
        return sortSelectDesktop;
    }
    return sortSelectMobile;
};
const handleCheckboxChange = () => {
    $('.showTotalSelectedCountFilter').text((showFilterPill.length > 0) ? '(' + showFilterPill.length + ')' : '');
    if (htmlNode.classList.contains('noScroll')) {
        htmlNode.classList.toggle('noScroll');
    }
};
const updateFiltersToggleState = (formNode) => {
    const toggleSwitchNodes = formNode.querySelectorAll('[data-toggle-switch]');
    const state = [];
    toggleSwitchNodes.forEach((node) => {
        const sectionNode = node.closest('[data-filter-type]');
        state.push({
            id: sectionNode.id,
            state: sectionNode.dataset.toggleState
        });
        showHideFilterCategoryCount(sectionNode);
    });
    localStorage.setItem(localStorageKey, JSON.stringify(state));
};
const bindMobileNav = () => {
    const displayed = filtersContainerNode.dataset.isMobileDisplay === 'true';
    filtersContainerNode.dataset.isMobileDisplay = !displayed;
    htmlNode.classList.toggle('noScroll');
    overlayNode.classList.toggle('hide');
    filtersSidebarContainerNode.classList.remove('hide');
    handleCheckboxChange();
};
const closeFilters = () => {
    filtersContainerNode.dataset.isMobileDisplay = false;
    overlayNode.classList.add('hide');
    filtersSidebarContainerNode.classList.add('hide');
    htmlNode.classList.remove('noScroll');
    handleCheckboxChange();
};
const sort = (filterHandler) => {
    const sortInput = document.querySelector('input[type="hidden"][name="sort"]');
    const activeSortValue = activeSortSelector().value;
    sortInput.value = activeSortValue;
    sortSelectDesktop.value = activeSortValue;
    sortSelectMobile.value = activeSortValue;
    if (filterHandler) {
        filterHandler(true);
    }
};
const hydrateFilters = (filterHandler) => {
    const formNode = document.querySelector('[data-filters-input-container]');
    const resetFormNode = formNode.querySelector('.columnHeadingResetBtn button');
    const toggleSwitchNodes = formNode.querySelectorAll('[data-toggle-switch]');
    const toggleFiltersNodes = document.querySelectorAll('[data-toggle-filters]');
    const radioBtnNodes = formNode.querySelectorAll('input[type="radio"]');
    const checkboxBtnNodes = formNode.querySelectorAll('input[type="checkbox"]:not(.monthlyCheckInput):not(.upfrontCheckInput)');
    sort();
    if (checkboxBtnNodes.length) {
        checkboxBtnNodes.forEach(checkboxBtnNode =>
            checkboxBtnNode.addEventListener('click', (evt) => {
                evt.preventDefault();
                filterHandler(true);
                return false;
            })
        );
    }
    resetFormNode.addEventListener('click', () => {
        showFilterPill = [];
        showFilterPillId = [];
        filterHandler(false);
        return false;
    });
    if (radioBtnNodes.length) {
        radioBtnNodes.forEach(radioBtnNode =>
            radioBtnNode.addEventListener('click', () => {
                if (radioBtnNode.getAttribute('checked')) {
                    radioBtnNode.checked = false;
                    filterHandler(true);
                }
            })
        );
    }
    toggleSwitchNodes.forEach((toggleSwitchNode) => {
        const sectionNode = toggleSwitchNode.closest('[data-filter-type]');
        // Make it focusable if it's not already
        if (!toggleSwitchNode.hasAttribute('tabindex')) {
            toggleSwitchNode.setAttribute('tabindex', '0');
        }
        // Optional but recommended for accessibility
        // Earlier this code was there removed as part of CDMA-624 now adding again we checked in prod [data-filters-input-container]
        // [data-toggle-switch] attribute not in prod
        toggleSwitchNode.setAttribute(
            'aria-expanded',
            sectionNode.dataset.toggleState === 'open'
        );
        if (!($('#filterToggleState').length)) {
            const filtersState = JSON.parse(localStorage.getItem(localStorageKey));
            if (filtersState) {
                const memState = filtersState.find(el => el.id === sectionNode.id);
                if (memState) {
                    sectionNode.dataset.toggleState = memState.state;
                }
            }
        }
        const toggleAccordion = () => {
            // Earlier this code was there removed as part of CDMA-624 now adding again we checked in prod [data-filters-input-container]
            // [data-toggle-switch] attribute not in prod
            const state = sectionNode.dataset.toggleState;
            const newState = state === 'open' ? 'closed' : 'open';

            sectionNode.dataset.toggleState = newState;
            toggleSwitchNode.setAttribute(
                'aria-expanded',
                newState === 'open'
            );

            updateFiltersToggleState(form);
            showHideFilterCategoryCount(sectionNode);
        };
        toggleSwitchNode.addEventListener('click', () => {
            updateFiltersToggleState(form);
            toggleAccordion();
        });
        // Keyboard support
        toggleSwitchNode.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                // Prevent page scroll on Space
                e.preventDefault();
                toggleAccordion();
            }
        });
        showHideFilterCategoryCount(sectionNode);
    });
    toggleFiltersNodes.forEach((toggleFiltersNode) => {
        toggleFiltersNode.removeEventListener('click', bindMobileNav);
        toggleFiltersNode.addEventListener('click', bindMobileNav);
    });
    filtersHide();
    return formNode;
};
const initFilterPillResetBtnShowHide = () => {
    if ($('.cpwFilterClear').length) {
        $('.cpwFilterClear').each(function() {
            if ($(this).attr('data-remove') == 'out_of_stock') {
                $('#outOfStockToggle').val('desc');
            }
            if (!(showFilterPillId.includes($(this).attr('data-remove')))) {
                showFilterPill.push($(this).attr('data-pill'));
                showFilterPillId.push($(this).attr('data-remove'));
            }
        });
        $('.filterPillResetBtn').show();
    }
    if ($('.cpwFilterClearMonthlyMinMax').length) {
        showFilterPill.push($('.cpwFilterClearMonthlyMinMax').attr('data-pill'));
        showFilterPillId.push('cpwFilterClearMonthlyMinMax');
    }
    if ($('.cpwFilterClearUpfrontMinMax').length) {
        showFilterPill.push($('.cpwFilterClearUpfrontMinMax').attr('data-pill'));
        showFilterPillId.push('cpwFilterClearUpfrontMinMax');
    }
    handleCheckboxChange();
    showHideApplyClearAllButton();
};
const handlePillData = ($this, tagName = '', tagRemove = '') => {
    if ($this.prop('checked') == true) {
        showFilterPill.push((tagName == '') ? $this.attr('data-tag-show') : tagName);
        showFilterPillId.push((tagRemove == '') ? $this.attr('data-tag-id') : tagRemove);
        handleCheckboxChange();
    } else {
        modifyPillData((tagRemove == '') ? $this.attr('data-tag-id') : tagRemove);
        handleCheckboxChange();
    }
};
const modifyPillData = (dataRemove) => {
    const index = showFilterPillId.indexOf(dataRemove);
    if (index > -1) {
        showFilterPill.splice(index, 1);
        showFilterPillId.splice(index, 1);
    }
};
const checkLengthofText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
};
const showHideApplyClearAllButton = () => {
    if (showFilterPillId.length == 0) {
        $('.filterPillResetBtn').hide();
        if (window.matchMedia('(max-width: 1000px)').matches) {
            $('.selectedFiltershowhide').hide();
        }
    } else {
        $('.filterPillResetBtn').show();
        if (window.matchMedia('(max-width: 1000px)').matches) {
            $('.selectedFiltershowhide').show();
        }
    }
};
const putPillOfSelectedFilters = () => {
    if (showFilterPill.length > 0) {
        let checkCheckedFilters = [];
        $('.cpwInputFilter').each(function() {
            if ($(this).prop('checked') == true) {
                checkCheckedFilters.push($(this).attr('data-tag-show'));
            }
        });
        if ($('.cpwInputFilteris_refurbished')[0]) {
            if ($('.cpwInputFilteris_refurbished').prop('checked') == true) {
                checkCheckedFilters.push('Refurbished');
            }
        }
        if ($('.cpwInputFilterout_of_stock')[0]) {
            if ($('.cpwInputFilterout_of_stock').prop('checked') == true) {
                checkCheckedFilters.push('In stock only');
            }
        }
        if ($('.monthlyMinVal')[0] && ($('.monthlyMinVal').val() != '' || $('.monthlyMaxVal').val() != '')) {
            let monthlyMin = ($('.monthlyMinVal').val() == '' && $('.monthlyMaxVal').val() != '') ? 'min' : '£' + $('.monthlyMinVal').val();
            let monthlyMax = ($('.monthlyMinVal').val() != '' && $('.monthlyMaxVal').val() == '') ? 'max' : '£' + $('.monthlyMaxVal').val();
            checkCheckedFilters.push(monthlyMin + ' - ' + monthlyMax);
        }
        if ($('.upfrontMinVal')[0] && ($('.upfrontMinVal').val() != '' || $('.upfrontMaxVal').val() != '')) {
            let upfrontMin = ($('.upfrontMinVal').val() == '' && $('.upfrontMaxVal').val() != '') ? 'min' : '£' + $('.upfrontMinVal').val();
            let upfrontMax = ($('.upfrontMinVal').val() != '' && $('.upfrontMaxVal').val() == '') ? 'max' : '£' + $('.upfrontMaxVal').val();
            checkCheckedFilters.push(upfrontMin + ' - ' + upfrontMax);
        }
        if ($('.filtercontrol_upfront_cost_sim_free_min')[0] && ($('.filtercontrol_upfront_cost_sim_free_min').val() != '' || $('.filtercontrol_upfront_cost_sim_free_max').val() != '')) {
            let upfrontMinSimf = ($('.filtercontrol_upfront_cost_sim_free_min').val() == '' && $('.filtercontrol_upfront_cost_sim_free_max').val() != '') ? 'min' : '£' + $('.filtercontrol_upfront_cost_sim_free_min').val();
            let upfrontMaxSimf = ($('.filtercontrol_upfront_cost_sim_free_min').val() != '' && $('.filtercontrol_upfront_cost_sim_free_max').val() == '') ? 'max' : '£' + $('.filtercontrol_upfront_cost_sim_free_max').val();
            checkCheckedFilters.push(upfrontMinSimf + ' - ' + upfrontMaxSimf);
        }
        if (checkCheckedFilters.length > 0) {
            let tempShowFilterPill = [];
            let tempShowFilterPillId = [];
            $.each(showFilterPill, function(index, item) {
                if (checkCheckedFilters.includes(item)) {
                    tempShowFilterPill.push(item);
                    tempShowFilterPillId.push(showFilterPillId[index]);
                }
            });
            showFilterPill = tempShowFilterPill;
            showFilterPillId = tempShowFilterPillId;
        }
        if (showFilterPill.length > 0) {
            $('.cpwFilterTag').html('');
            let html = '';
            $.each(showFilterPill, function(index, filterPill) {
                if (showFilterPillId[index] == 'cpwFilterClearMonthlyMinMax') {
                    html += '\
                        <div class="col-lg-4 filterTag filterTagMonthlyMinMax">\
                            <span class="cpwFilterText">\
                                ' + filterPill + ' <button class="btn-focus" type="button"><img class="cpwFilterClearMonthlyMinMax tabindexFocusElFilter" src="/img/crosssign.svg" data-pill="' + filterPill + '" alt="' + filterPill + '" width="20" height="20"></button>\
                            </span>\
                        </div>\
                    ';
                } else if (showFilterPillId[index] == 'cpwFilterClearUpfrontMinMax') {
                    html += '\
                        <div class="col-lg-4 filterTag filterTagUpfrontMinMax">\
                            <span class="cpwFilterText">\
                                ' + filterPill + ' <button class="btn-focus" type="button"><img class="cpwFilterClearUpfrontMinMax tabindexFocusElFilter" src="/img/crosssign.svg" data-pill="' + filterPill + '" alt="' + filterPill + '" width="20" height="20"></button>\
                            </span>\
                        </div>\
                    ';
                } else {
                    html += '\
                        <div class="col-lg-4 filterTag filterTag' + showFilterPillId[index] + '">\
                            <span class="cpwFilterText cpwFilterTextDivDesktop">' + checkLengthofText(filterPill, 32) + '<button class="btn-focus" type="button"><img class="cpwFilterClear tabindexFocusElFilter" data-remove="' + showFilterPillId[index] + '" src="/img/crosssign.svg" data-pill="' + checkLengthofText(filterPill, 32) + '" alt="' + filterPill + '" width="20" height="20"></button></span>\
                            <span class="cpwFilterText cpwFilterTextDivMobile">' + checkLengthofText(filterPill, 28) + '<button class="btn-focus" type="button"><img class="cpwFilterClear tabindexFocusElFilter" data-remove="' + showFilterPillId[index] + '" src="/img/crosssign.svg" data-pill="' + checkLengthofText(filterPill, 28) + '" alt="' + filterPill + '" width="20" height="20"></button></span>\
                        </div>\
                    ';
                }
            });
            $('.cpwFilterTag').html(html);
        }
    }
};
const checkZoomLevel = () => {
    const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
    if (zoomLevel >= 1.5 && zoomLevel <= 5) {
        document.body.classList.add('zoom-150-500');
    } else {
        document.body.classList.remove('zoom-150-500');
    }
};
const initSetFilterToggleState = () => {
    if ($('#filterToggleState').length) {
        let filterToggleState = JSON.parse($('#filterToggleState').val());
        if (filterToggleState.length > 0) {
            $.each(filterToggleState, function(key, toggleData) {
                if ($('#filter_section_' + toggleData.key).length && $('#filter_section_' + toggleData.key).attr('data-toggle-state')) {
                    $('#filter_section_' + toggleData.key).attr('data-toggle-state', toggleData.state);
                }
            });
        }
    }
};
const showHideFilterCategoryCount = (sectionNode) => {
    let section_id = sectionNode.id;
    let fc = section_id.substring(14);
    let fc_count = $('input[name="filter' + fc + '[]"]:checked').length;
    $('#fc_count' + fc).html('(' + fc_count + ')');
    let fc_toggleState = $('#' + section_id).attr('data-toggle-state');
    if (fc_toggleState == 'closed' && fc_count > 0) {
        $('#fc_count' + fc).show();
    } else {
        $('#fc_count' + fc).hide();
    }
};
const showMore = (hideClass, showClass, showMore, showLess) => {
    $('.' + hideClass).addClass(showClass).removeClass(hideClass);
    $('.' + showMore).addClass(showLess).removeClass(showMore);
    $('.' + showLess).html('- Show less');
};
const showLess = (showClass, hideClass, showLess, showMore, showLength) => {
    $('.' + showClass).addClass(hideClass).removeClass(showClass);
    $('.' + showLess).addClass(showMore).removeClass(showLess);
    $('.' + showMore).html('+ Show ' + (parseInt($('.' + showLength).length) - parseInt(5)) + ' more');
};
const getFilterAppliedLength = () => {
    let countBrand = 0;
    let brandName = '';
    let countNetWork = 0;
    let networkName = '';
    let countOther = 0;
    $('.cpwInputFilter').each(function() {
        if ((($(this).attr('name') == 'filter_brand_featured[]' || $(this).attr('name') == 'filter_brand_featured_accessories[]') && $(this).prop('checked') == true)) {
            countBrand = parseInt(countBrand) + parseInt(1);
            brandName = $(this).val();
        } else if ($(this).attr('name') == 'filter_network[]' && $(this).prop('checked') == true) {
            countNetWork = parseInt(countNetWork) + parseInt(1);
            networkName = $(this).val();
        } else if (($(this).attr('name') != 'filter_brand_featured[]' || $(this).attr('name') != 'filter_brand_featured_accessories[]') && $(this).attr('name') != 'filter_network[]' && $(this).prop('checked') == true) {
            countOther = parseInt(countOther) + parseInt(1);
        }
    });
    $('.monthlyCostInput').each(function() {
        if ($(this).val() != '') {
            countOther = parseInt(countOther) + parseInt(1);
        }
    });
    if ($('.cpwInputFilteris_refurbished')[0] && $('.cpwInputFilteris_refurbished').prop('checked') == true) {
        countOther = parseInt(countOther) + parseInt(1);
    }
    if ($('.cpwInputFilterout_of_stock')[0] && $('.cpwInputFilterout_of_stock').prop('checked') == true) {
        countOther = parseInt(countOther) + parseInt(1);
    }
    return {
        brandName: brandName,
        countBrand: countBrand,
        networkName: networkName,
        countNetWork: countNetWork,
        countOther: countOther
    };
};
function includeUrls(url) {
    return (url.pathname.includes('/mobiles/pay-monthly') || url.pathname.includes('/mobiles/sim-free') || url.pathname.includes('/refurbished-phones') || url.pathname.includes('/accessories/all') || url.pathname.includes('/accessories/cases') || url.pathname.includes('/accessories/screen-protector') || url.pathname.includes('/accessories/headphones') || url.pathname.includes('/accessories/chargers') || url.pathname.includes('/accessories/powerbanks')) ? true : false;
}
function excludeNetwork(url) {
    return (!url.pathname.includes('/mobiles/sim-free') && !url.pathname.includes('/refurbished-phones') && !url.pathname.includes('/accessories/all') && !url.pathname.includes('/accessories/cases') && !url.pathname.includes('/accessories/screen-protector') && !url.pathname.includes('/accessories/headphones') && !url.pathname.includes('/accessories/chargers') && !url.pathname.includes('/accessories/powerbanks')) ? true : false;
}
function fallBackUrl(url) {
    return ((url.pathname.includes('/mobiles/pay-monthly') && !(url.pathname == '/mobiles/pay-monthly')) || (url.pathname.includes('/mobiles/sim-free') && !(url.pathname == '/mobiles/sim-free')) || (url.pathname.includes('/refurbished-phones') && !(url.pathname == '/refurbished-phones')) || (url.pathname.includes('/accessories/all') && !(url.pathname == '/accessories/all')) || (url.pathname.includes('/accessories/cases') && !(url.pathname == '/accessories/cases')) || (url.pathname.includes('/accessories/screen-protector') && !(url.pathname == '/accessories/screen-protector')) || (url.pathname.includes('/accessories/headphones') && !(url.pathname == '/accessories/headphones')) || (url.pathname.includes('/accessories/chargers') && !(url.pathname == '/accessories/chargers')) || (url.pathname.includes('/accessories/powerbanks') && !(url.pathname == '/accessories/powerbanks'))) ? true : false;
}
let form = hydrateFilters(filterHandler);
updateFiltersToggleState(form);
let resultsContainer = document.querySelector('[data-results-container]');
let dealOptionsContainer = document.querySelector('#dealOptions');
let dealMediaContainer = document.querySelector('#dealMedia');
let dealBreadcrumbsContainer = document.querySelector('.facetBreadCrumb');
let pageCopyAndHeading = document.querySelector('.pageCopyAndHeading');
let listingCmsAdditionalContent = document.querySelector('#listing-cms-additional-content');
const spinner = document.querySelector('[data-loading-overlay]');
function filterHandler(hasParams) {
    const url = new URL(document.URL);
    let hiddenFlagParam = '';
    if (url.search.includes('hiddenFlag')) {
        const paramsUrl = new URLSearchParams(window.location.search);
        hiddenFlagParam = (hasParams) ? '&hiddenFlag=true&prodId=' + paramsUrl.get('prodId') : '?hiddenFlag=true&prodId=' + paramsUrl.get('prodId');
    }
    const params = new URLSearchParams(new FormData(form)).toString();

    let fetchUrl = `${url.origin}${url.pathname}`;
    let addParams = true;
    if (includeUrls(url)) {
        if (hasParams) {
            let filterApplied = getFilterAppliedLength();
            // const hasSort = params.includes('sort=');
            const defaultSortValue = sortSelectDesktop ? sortSelectDesktop.querySelector('option').value : sortSelectMobile.querySelector('option').value;
            const sortParam = new URLSearchParams(params).get('sort');
            const hasSort = sortParam && sortParam !== defaultSortValue;
            // const hasSort = params.includes('sort=') && !params.includes('sort=default');
            if (addParams && filterApplied.countBrand === 1 && filterApplied.countNetWork === 0 && filterApplied.countOther === 0) {
                // fetchUrl += `/${filterApplied.brandName.replace(' ', '-')}`;
                if (fallBackUrl(url)) {
                    fetchUrl = fetchUrl.replace(/\/[^/]+$/, '');
                }
                fetchUrl += `/${filterApplied.brandName.replace(/\s+/g, '-')}`;
                if (!hasSort) {
                    addParams = false;
                }
            }
            if (addParams && excludeNetwork(url) && filterApplied.countNetWork === 1 && filterApplied.countBrand === 0 && filterApplied.countOther === 0) {
                if (fallBackUrl(url)) {
                    fetchUrl = fetchUrl.replace(/\/[^/]+$/, '');
                }
                fetchUrl += `/${filterApplied.networkName}`;
                if (!hasSort) {
                    addParams = false;
                }
            }
            if (addParams && fallBackUrl(url)) {
                fetchUrl = fetchUrl.replace(/\/[^/]+$/, '');
            }
        } else {
            fetchUrl = fallBackUrl(url) ? fetchUrl.replace(/\/[^/]+$/, '') : fetchUrl;
        }
        fetchUrl = fetchUrl.toLowerCase();
        $('link[rel="canonical"]').attr('href', fetchUrl);
    }
    if (hasParams && addParams) {
        fetchUrl += `?${params}`;
    }
    fetchUrl += hiddenFlagParam;
    document.body.classList.add('noScrollToTop');
    spinner.dataset.activeTasks = '1';
    fetch(fetchUrl, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(data => data.json()).then((data) => {
        history.pushState({}, null, fetchUrl);
        resultsContainer.classList.add('is-loading');
        form.parentElement.innerHTML = data.listing.filterControlForm;
        resultsContainer.innerHTML = data.listing.deals;
        if (data.listing.dealOptions) {
            dealOptionsContainer.innerHTML = data.listing.dealOptions;
            dealOptionsChange();
        }
        if (data.listing.dealMedia) {
            dealMediaContainer.innerHTML = data.listing.dealMedia;
        }
        if (data.listing.dealBreadcrumbs && data.listing.dealBreadcrumbs != '') {
            if ($('#dealBreadcrumbs').length) {
                $('#dealBreadcrumbs').html('');
                $('#dealBreadcrumbs').html(data.listing.dealBreadcrumbs);
            } else {
                dealBreadcrumbsContainer.innerHTML = data.listing.dealBreadcrumbs;
            }
        }
        if (data.listing.pageCopy && data.listing.pageCopy != '') {
            pageCopyAndHeading.innerHTML = data.listing.pageCopy;
        }
        if (data.listing.additionalContent && data.listing.additionalContent != '') {
            listingCmsAdditionalContent.innerHTML = data.listing.additionalContent;
        }
        if (data.listing.metaDescription && data.listing.metaDescription != '') {
            $('meta[name="description"]').attr('content', data.listing.metaDescription.trim());
        }
        if (data.listing.title && data.listing.title != '') {
            const formattedTitle = data.listing.title.trim() + ' | Carphone Warehouse';
            $('title').text(formattedTitle);
        }
        // If we have the ASA message on the response object, update all the ASA message containers on the page,
        // with the new message fetched from the server.
        let asaMessageElements = document.querySelectorAll('.filter-listing-results-asa-message .asa-message');
        asaMessageElements.forEach(function(currentValue) {
            currentValue.innerHTML = data.asaMessage;
            for (const child of currentValue.closest('.filter-listing-results-asa-message').children) {
                child.style.display = data.asaMessage ? 'block' : 'none';
            }
        });
        if (data.listing.numberOfResults) {
            document.querySelectorAll('.totalResults span').forEach((span) => {
                span.textContent = data.listing.numberOfResults;
            });
        } else {
            document.querySelectorAll('.totalResults span').forEach((span) => {
                span.textContent = '0';
            });
        }
        if (loadMoreDealsButton) {
            loadMoreDealsButton.dataset.pageState = 1;
            if (data.listing.islastpage) {
                loadMoreDealsButton.classList.add('hide');
            } else {
                loadMoreDealsButton.classList.remove('hide');
            }
        }
        if (!hasParams) {
            sortSelectDesktop.value = sortSelectDesktop.querySelector('option').value;
            sortSelectMobile.value = sortSelectMobile.querySelector('option').value;
            sort();
        }
        form = hydrateFilters(filterHandler);
        document.body.classList.remove('noScrollToTop');
        if (htmlNode.classList.contains('noScroll')) {
            htmlNode.classList.toggle('noScroll');
        }
        spinner.dataset.activeTasks = '0';
        setTimeout(() => [
            removeEmptyTags,
            initAccordions,
            equaliseProductHeights,
            countdownClock,
            setTimeout(resultsContainer.classList.remove('is-loading'), 100)
        ].forEach(fn => typeof fn === 'function' && fn()), 0);
        $('html, body').animate({
            scrollTop: $('.resultsDiv').offset().top - 30
        }, 'slow');
        // after selection, focus now shifts to the first product on the PLP.
        setTimeout(() => {
            let focusEl = document.querySelector('[data-results-container] [data-product-title] a') ||
                  document.querySelector('[data-results-container] .tariff-info-link');

            if (focusEl) {
                focusEl.setAttribute('tabindex', '-1');
                focusEl.focus();
            }
        }, 300);
        putPillOfSelectedFilters();
        showHideApplyClearAllButton();
        reloadFeefoScript();
    });
}
const reloadFeefoScript = () => {
    const old = document.querySelector('script[src*="feefo.com/api/javascript"]');
    if (old) {
        old.remove();
    }
    const s = document.createElement('script');
    s.src = 'https://api.feefo.com/api/javascript/carphone-warehouse';
    s.async = true;
    document.body.appendChild(s);
};
const init = () => {
    overlayNode.addEventListener('click', closeFilters);
    sortSelectDesktop.addEventListener('input', () => sort(filterHandler));
    sortSelectMobile.addEventListener('input', () => sort(filterHandler));
    window.addEventListener('resize', debounce(() => {
        if (window.innerWidth >= 1024) {
            closeFilters();
        }
    }));
};
export default init;
let showFilterPill = [];
let showFilterPillId = [];
$(document).ready(function() {
    reloadFeefoScript();
    handleCheckboxChange();
    initFilterPillResetBtnShowHide();
    initSetFilterToggleState();
    $(document).on('click', '.showMoreBrand', function(e) {
        e.preventDefault();
        showMore('brandFilterHide', 'brandFilterShow', 'showMoreBrand', 'showLessBrand');
    });
    $(document).on('click', '.showLessBrand', function(e) {
        e.preventDefault();
        showLess('brandFilterShow', 'brandFilterHide', 'showLessBrand', 'showMoreBrand', 'brandFilter');
    });
    $(document).on('click', '.showMoreGwp', function(e) {
        e.preventDefault();
        showMore('gwpFilterHide', 'gwpFilterShow', 'showMoreGwp', 'showLessGwp');
    });
    $(document).on('click', '.showLessGwp', function(e) {
        e.preventDefault();
        showLess('gwpFilterShow', 'gwpFilterHide', 'showLessGwp', 'showMoreGwp', 'gwpFilter');
    });
    $(document).on('click', '.showMorePhoneType', function(e) {
        e.preventDefault();
        showMore('phoneTypeFilterHide', 'phoneTypeFilterShow', 'showMorePhoneType', 'showLessPhoneType');
    });
    $(document).on('click', '.showLessPhoneType', function(e) {
        e.preventDefault();
        showLess('phoneTypeFilterShow', 'phoneTypeFilterHide', 'showLessPhoneType', 'showMorePhoneType', 'phoneTypeFilter');
    });
    $(document).on('click', '.showMoreProductSubtype', function(e) {
        e.preventDefault();
        showMore('productSubtypeFilterHide', 'productSubtypeFilterShow', 'showMoreProductSubtype', 'showLessProductSubtype');
    });
    $(document).on('click', '.showLessProductSubtype', function(e) {
        e.preventDefault();
        showLess('productSubtypeFilterShow', 'productSubtypeFilterHide', 'showLessProductSubtype', 'showMoreProductSubtype', 'productSubtypeFilter');
    });
    $(document).on('click', '.showMoreStorage', function(e) {
        e.preventDefault();
        showMore('storageFilterHide', 'storageFilterShow', 'showMoreStorage', 'showLessStorage');
    });
    $(document).on('click', '.showLessStorage', function(e) {
        e.preventDefault();
        showLess('storageFilterShow', 'storageFilterHide', 'showLessStorage', 'showMoreStorage', 'storageFilter');
    });
    $(document).on('click', '.showMoreColor', function(e) {
        e.preventDefault();
        showMore('colorFilterHide', 'colorFilterShow', 'showMoreColor', 'showLessColor');
    });
    $(document).on('click', '.showLessColor', function(e) {
        e.preventDefault();
        showLess('colorFilterShow', 'colorFilterHide', 'showLessColor', 'showMoreColor', 'colorFilter');
    });
    function escapeSelector(sel) {
        return sel
            .replace(/&amp;/g, '&')
            .replace(/&/g, '\\&');
    }
    $(document).on('click', '.cpwFilterClear', function() {
        let dataId = $(this).attr('data-remove');
        modifyPillData(dataId);
        let safeSelector = '.cpwInputFilter' + escapeSelector(dataId);
        $(safeSelector).trigger('click');
    });
    $(document).on('keypress', '.isNumber', function(evt) {
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        let returnStatus = false;
        returnStatus = (charCode > 31 && (charCode < 48 || charCode > 57)) ? false : true;
        returnStatus = (returnStatus) ? (($(this).val().length < 4) ? true : false) : returnStatus;
        return returnStatus;
    });
    $(document).on('focus', '.monthlyCostInput', function() {
        $('.monthlyCostInput').removeClass('active-input');
        $(this).addClass('active-input');
    });
    $(document).on('blur', '.monthlyCostInput', function() {
        $(this).removeClass('active-input');
    });
    $(document).on('focus', '.monthlyCostInput', function() {
        $(this).attr('inputmode', 'numeric');
        $(this).attr('_originaltype', 'number');
    });
    $(document).on('click', '.cpwInputFilter', function() {
        handlePillData($(this));
    });
    $(document).on('click', '.cpwInputFilteris_refurbished', function() {
        handlePillData($(this), 'Refurbished', 'is_refurbished');
    });
    $(document).on('click', '.cpwInputFilterout_of_stock', function() {
        handlePillData($(this), 'In stock only', 'out_of_stock');
    });
    $(document).on('click', '.cpwFilterClearMonthlyMinMax', function(e) {
        e.preventDefault();
        modifyPillData('cpwFilterClearMonthlyMinMax');
        $('.monthlyMinVal').val('');
        $('.monthlyMaxVal').val('');
        filterHandler(true);
    });
    $(document).on('click', '.cpwFilterClearUpfrontMinMax', function(e) {
        e.preventDefault();
        modifyPillData('cpwFilterClearUpfrontMinMax');
        $('.upfrontMinVal').val('');
        $('.upfrontMaxVal').val('');
        filterHandler(true);
    });
    $(document).on('click', '.monthlyCostGo', function(e) {
        e.preventDefault();
        $(this).prop('disabled', true);
        $('.monthlyCostError').html('');
        $('.upfrontCostErrorShow').html('');
        $('.upfrontCostErrorShowSimf').html('');
        let proceed = true;
        if ($(this).hasClass('monthlyButtonGo')) {
            if ($('.monthlyMinVal').val() == '' && $('.monthlyMaxVal').val() == '') {
                $('.monthlyCostErrorShow').html('<span>You must put either Min value or Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
            if (proceed && $('.monthlyMinVal').val() != '' && $('.monthlyMaxVal').val() != '' && parseInt($('.monthlyMinVal').val()) > parseInt($('.monthlyMaxVal').val())) {
                $('.monthlyCostErrorShow').html('<span>Min value must be lesser than Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
        }
        if ($(this).hasClass('upfrontButtonGo')) {
            if ($('.upfrontMinVal').val() == '' && $('.upfrontMaxVal').val() == '') {
                $('.upfrontCostErrorShow').html('<span>You must put either Min value or Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
            if (proceed && $('.upfrontMinVal').val() != '' && $('.upfrontMaxVal').val() != '' && parseInt($('.upfrontMinVal').val()) > parseInt($('.upfrontMaxVal').val())) {
                $('.upfrontCostErrorShow').html('<span>Min value must be lesser than Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
        }
        if ($(this).hasClass('upfrontButtonGoSimf')) {
            if ($('.filtercontrol_upfront_cost_sim_free_min').val() == '' && $('.filtercontrol_upfront_cost_sim_free_max').val() == '') {
                $('.upfrontCostErrorShowSimf').html('<span>You must put either Min value or Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
            if (proceed && $('.filtercontrol_upfront_cost_sim_free_min').val() != '' && $('.filtercontrol_upfront_cost_sim_free_max').val() != '' && parseInt($('.filtercontrol_upfront_cost_sim_free_min').val()) > parseInt($('.filtercontrol_upfront_cost_sim_free_max').val())) {
                $('.upfrontCostErrorShowSimf').html('<span>Min value must be lesser than Max value</span>');
                proceed = false;
                $(this).prop('disabled', false);
                return false;
            }
        }
        if (proceed) {
            if (($('.monthlyMinVal').val() != '' && $('.monthlyMinVal').val() !== undefined) || ($('.monthlyMaxVal').val() != '' && $('.monthlyMaxVal').val() !== undefined)) {
                let monthlyMin = ($('.monthlyMinVal').val() == '' && $('.monthlyMaxVal').val() != '') ? 'min' : '£' + $('.monthlyMinVal').val();
                let monthlyMax = ($('.monthlyMinVal').val() != '' && $('.monthlyMaxVal').val() == '') ? 'max' : '£' + $('.monthlyMaxVal').val();
                if (monthlyMin !== undefined && monthlyMax !== undefined) {
                    $('.monthlyCheckInput').each(function() {
                        if ($(this).prop('checked') == true) {
                            modifyPillData($(this).attr('data-tag-id'));
                        }
                    });
                    modifyPillData('cpwFilterClearMonthlyMinMax');
                    showFilterPill.push(monthlyMin + ' - ' + monthlyMax);
                    showFilterPillId.push('cpwFilterClearMonthlyMinMax');
                    $('.monthlyCheckInput').prop('checked', false);
                }
            }
            if (($('.upfrontMinVal').val() != '' && $('.upfrontMinVal').val() !== undefined) || ($('.upfrontMaxVal').val() != '' && $('.upfrontMaxVal').val() !== undefined)) {
                let upfrontMin = ($('.upfrontMinVal').val() == '' && $('.upfrontMaxVal').val() != '') ? 'min' : '£' + $('.upfrontMinVal').val();
                let upfrontMax = ($('.upfrontMinVal').val() != '' && $('.upfrontMaxVal').val() == '') ? 'max' : '£' + $('.upfrontMaxVal').val();
                if (upfrontMin !== undefined && upfrontMax !== undefined) {
                    $('.upfrontCheckInput').each(function() {
                        if ($(this).prop('checked') == true) {
                            modifyPillData($(this).attr('data-tag-id'));
                        }
                    });
                    modifyPillData('cpwFilterClearUpfrontMinMax');
                    showFilterPill.push(upfrontMin + ' - ' + upfrontMax);
                    showFilterPillId.push('cpwFilterClearUpfrontMinMax');
                    $('.upfrontCheckInput').prop('checked', false);
                }
            }
            if (($('.filtercontrol_upfront_cost_sim_free_min').val() != '' && $('.filtercontrol_upfront_cost_sim_free_min').val() !== undefined) || ($('.filtercontrol_upfront_cost_sim_free_max').val() != '' && $('.filtercontrol_upfront_cost_sim_free_max').val() !== undefined)) {
                let upfrontMinSimf = ($('.filtercontrol_upfront_cost_sim_free_min').val() == '' && $('.filtercontrol_upfront_cost_sim_free_max').val() != '') ? 'min' : '£' + $('.filtercontrol_upfront_cost_sim_free_min').val();
                let upfrontMaxSimf = ($('.filtercontrol_upfront_cost_sim_free_min').val() != '' && $('.filtercontrol_upfront_cost_sim_free_max').val() == '') ? 'max' : '£' + $('.filtercontrol_upfront_cost_sim_free_max').val();
                if (upfrontMinSimf !== undefined && upfrontMaxSimf !== undefined) {
                    $('.upfrontCheckInput').each(function() {
                        if ($(this).prop('checked') == true) {
                            modifyPillData($(this).attr('data-tag-id'));
                        }
                    });
                    modifyPillData('cpwFilterClearUpfrontMinMax');
                    showFilterPill.push(upfrontMinSimf + ' - ' + upfrontMaxSimf);
                    showFilterPillId.push('cpwFilterClearUpfrontMinMax');
                    $('.upfrontCheckInput').prop('checked', false);
                }
            }
            filterHandler(true);
        }
        return false;
    });
    $(document).on('click', '.monthlyCheckInput', function(e) {
        e.preventDefault();
        $('.monthlyMinVal').val('');
        $('.monthlyMaxVal').val('');
        modifyPillData('cpwFilterClearMonthlyMinMax');
        filterHandler(true);
    });
    $(document).on('click', '.upfrontCheckInput', function(e) {
        e.preventDefault();
        $('.upfrontMinVal').val('');
        $('.upfrontMaxVal').val('');
        modifyPillData('cpwFilterClearUpfrontMinMax');
        filterHandler(true);
    });
});
window.addEventListener('resize', checkZoomLevel);
window.addEventListener('load', checkZoomLevel);
if (window.location.href.includes('/offers/')) {
    document.addEventListener('click', function() {
        const url = new URL(document.URL);
        let fetchUrl = `${url.origin}${url.pathname}`;
        const parts = window.location.pathname.split('/');
        const promo_id = parts[2];
        fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                promo_id: promo_id
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.status === true) {
                    window.location.href = '/';
                }
            });
    });
}
$(document).on('click', 'a.offer-link', function(e) {
    e.preventDefault();
    const atagUrl = $(this).attr('href');
    const $a = $('a.offer-link');
    const newTab = window.open(atagUrl, '_blank');
    if ($a.length === 0) {
        return;
    }
    const url = new URL(document.URL);
    let fetchUrl = `${url.origin}${url.pathname}`;
    const promo_id = $a.data('promoid');
    fetch(fetchUrl, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            promo_id: promo_id
        })
    })
        .then(res => res.json())
        .then((data) => {
            if (data.status === true) {
                newTab.location.href = '/';
            } else {
                newTab.location.href = atagUrl;
            }
        });
});
// Focus and press enter or space code start here
document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    const el = e.target;
    let img = null;
    if (el.classList.contains('btn-focus')) {
        img = el.querySelector('img');
    }
    if (el.classList.contains('tabindexFocusElFilter') && (el.tagName === 'IMG' || el.tagName === 'SPAN')) {
        img = el;
    }
    if (img) {
        const hasClass = img.classList.contains('tabindexFocusElFilter');
        if (hasClass) {
            e.preventDefault();
            img.click();
            return;
        }
    }
    const $el = $(el);
    const $input = $el.find("input[type='checkbox']");
    const input = $input[0];
    if ($el.hasClass('switch') && $el.hasClass('pull-right') && input && input.classList.contains('tabindexFocusElFilter')) {
        e.preventDefault();
        input.click();
    }
    if (input && input.classList.contains('form-checkbox-input') && input.classList.contains('tabindexFocusElFilter')) {
        e.preventDefault();
        input.click();
    }
});
